export { default as IconFacebook } from './facebook.svg';
export { default as IconInstagram } from './instagram.svg';
export { default as IconLinkedin } from './linkedin.svg';
export { default as IconPinterest } from './pinterest.svg';
export { default as IconTikTok } from './tiktok.svg';
export { default as IconYoutube } from './youtube.svg';
export { default as IconX } from './x.svg';
